import { render } from "./Work.vue?vue&type=template&id=773e8125&ts=true"
import script from "./Work.vue?vue&type=script&lang=ts"
export * from "./Work.vue?vue&type=script&lang=ts"

import "./Work.vue?vue&type=style&index=0&id=773e8125&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__